import axios from '@/api/axiosInstance';
import { setAxiosHeader } from '../axiosInterceptors';

export default async function login({
  login,
  password,
  preventRedirectOnUnauthorized = false,
}) {
  const response = await axios({
    method: 'post',
    url: `${process.env.NEXT_PUBLIC_API}/auth/login`,
    data: { login, password, timeOffset: new Date().getTimezoneOffset() },
    preventRedirectOnUnauthorized,
  });

  setAxiosHeader(response.data.token);

  return response.data;
}
